import React from 'react';
import type { ReactNode } from 'react';

interface FinalCardProps {
  title?: string;
  children: ReactNode;
}

const FinalCard: React.FC<FinalCardProps> = ({ title, children }) => {
  const colorClass = title === 'Oops!' ? ' final-card__title--red' : '';

  return (
    <div className='final-card'>
      <div className='final-card__content'>
        <div className={`final-card__title${colorClass}`}>{title}</div>
        {children}
      </div>
    </div>
  );
};

FinalCard.displayName = 'FinalCard';

export default FinalCard;
